import * as React from 'react';
import { Grid2 as Grid } from '@mui/material';
import { Button, TextField } from '../common';
import { BaseDialog, BaseDialogProps, BaseDialogState } from '../common/dialog/BaseDialog';

interface Props extends BaseDialogProps {
    readonly onCreate: (name: string, apiUrl: string, apiSecretKey: string) => void;
}

interface State extends BaseDialogState {
    readonly name: string;
    readonly apiUrl: string;
    readonly apiSecretKey: string;
}

export class CreateTitleDialog extends BaseDialog<Props, State> {
    state = this.initState();

    protected renderContent(): React.JSX.Element {
        const { name, apiUrl, apiSecretKey } = this.state;

        return (
            <Grid container={true} spacing={0}>
                <Grid size={12}>
                    <TextField
                        label="Name"
                        fullWidth={true}
                        value={name}
                        required={true}
                        variant="outlined"
                        onChange={this.updateName}
                        disabled={false}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        label="Api Url"
                        fullWidth={true}
                        value={apiUrl}
                        required={true}
                        variant="outlined"
                        onChange={this.updateApiUrl}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        label="Api Secret Key"
                        fullWidth={true}
                        value={apiSecretKey}
                        required={true}
                        variant="outlined"
                        onChange={this.updateApiSecretKey}
                    />
                </Grid>
            </Grid>
        );
    }

    protected renderActions(): React.JSX.Element {
        return (
            <Button text="Create" onClick={this.onCreate} variant="contained" disabled={!this.validateTitle()} />
        );
    }

    protected initState(): State {
        return {
            name: '',
            apiUrl: '',
            apiSecretKey: '',
        };
    }

    private updateName = (name: string) => this.setState({ name });

    private updateApiUrl = (apiUrl: string) => this.setState({ apiUrl });

    private updateApiSecretKey = (apiSecretKey: string) => this.setState({ apiSecretKey });

    private validateTitle = () =>  this.state.name !== '' && this.state.apiUrl !== '';

    private onCreate = () => {
        const { name, apiUrl, apiSecretKey } = this.state;
        this.props.onCreate(name, apiUrl, apiSecretKey);
        this.onClose();
    };
}
